var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDalle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 205 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #707070;\n      }\n\n      .cls-3 {\n        fill: #5f5b5b;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #5d5a5a;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_969",
    "data-name": "Raggruppa 969"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_552",
    "data-name": "Rettangolo 552",
    className: "cls-5",
    width: 205,
    height: 75,
    rx: 23,
    ry: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "DALL_E_3",
    "data-name": "DALL E 3",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m31.52,50v-25.06h7.665c3.827,0,6.9,1.154,9.223,3.465,2.321,2.31,3.482,5.332,3.482,9.064,0,3.757-1.161,6.785-3.482,9.083-2.322,2.298-5.396,3.447-9.223,3.447h-7.665Zm3.22-21.98v18.9h4.445c2.917,0,5.215-.834,6.895-2.502,1.68-1.668,2.52-3.984,2.52-6.948,0-2.939-.84-5.25-2.52-6.93-1.68-1.68-3.979-2.521-6.895-2.521h-4.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m57.875,50h-3.57l9.45-25.06h3.64l9.45,25.06h-3.57l-2.415-6.79h-10.535l-2.45,6.79Zm7.63-21.105l-4.095,11.306h8.33l-4.095-11.306h-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.604,50h-14.07v-25.06h3.22v21.979h10.85v3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m114.784,50h-14.07v-25.06h3.22v21.979h10.85v3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m143.973,24.94v3.079h-11.409v7.945h10.29v3.01h-10.29v7.945h11.409v3.08h-14.629v-25.06h14.629Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m174.178,43.21c0,2.1-.782,3.85-2.346,5.25-1.539,1.4-3.453,2.1-5.739,2.1-1.798,0-3.419-.536-4.865-1.609-1.47-1.12-2.462-2.578-2.976-4.375l2.941-1.226c.372,1.33.984,2.352,1.837,3.062.852.713,1.872,1.068,3.062,1.068,1.306,0,2.438-.408,3.396-1.226.932-.84,1.399-1.854,1.399-3.045s-.49-2.193-1.47-3.01c-.957-.816-2.112-1.226-3.465-1.226h-2.065v-3.01h1.819c1.283,0,2.334-.355,3.15-1.067s1.225-1.639,1.225-2.782c0-1.05-.385-1.901-1.154-2.556-.77-.652-1.785-.979-3.045-.979-2.03,0-3.418,1.038-4.165,3.115l-2.976-1.261c.537-1.47,1.436-2.659,2.695-3.569s2.742-1.365,4.445-1.365c2.123,0,3.908.63,5.355,1.89,1.422,1.214,2.135,2.789,2.135,4.726,0,2.31-1.074,4.024-3.221,5.145v.141c1.26.537,2.246,1.318,2.958,2.345.712,1.027,1.067,2.182,1.067,3.465Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_553",
    "data-name": "Rettangolo 553"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 118,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 118.5,
    y: 35.5,
    width: 5,
    height: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDalle3);
export default __webpack_public_path__ + "static/media/DALLE3.a8d836b87b3b4de2c729b0665b6a05ed.svg";
export { ForwardRef as ReactComponent };